export default {
  'apple-contacts': '/img/contact/icons/source/apple-contacts.svg',
  'apple-contacts_light': '/img/contact/icons/source/apple-contacts_light.svg',
  'apple-messages': '/img/contact/icons/source/apple-messages.svg',
  'apple-messages_light': '/img/contact/icons/source/apple-messages_light.svg',
  'calendar': '/img/contact/icons/source/calendar.svg',
  'calendar_light': '/img/contact/icons/source/calendar_light.svg',
  'card-dav': '/img/contact/icons/source/card-dav.svg',
  'card-dav_light': '/img/contact/icons/source/card-dav_light.svg',
  'chatgpt': '/img/contact/icons/source/chatgpt.svg',
  'chatgpt_light': '/img/contact/icons/source/chatgpt_light.svg',
  'contacts': '/img/contact/icons/source/contacts.svg',
  'contacts_light': '/img/contact/icons/source/contacts_light.svg',
  'csv': '/img/contact/icons/source/csv.svg',
  'csv_light': '/img/contact/icons/source/csv_light.svg',
  'email': '/img/contact/icons/source/email.svg',
  'email_light': '/img/contact/icons/source/email_light.svg',
  'facebook': '/img/contact/icons/source/facebook.svg',
  'facebook_light': '/img/contact/icons/source/facebook_light.svg',
  'linkedin': '/img/contact/icons/source/linkedin.svg',
  'linkedin_light': '/img/contact/icons/source/linkedin_light.svg',
  'manual': '/img/contact/icons/source/manual.svg',
  'manual_light': '/img/contact/icons/source/manual_light.svg',
  'messages': '/img/contact/icons/source/messages.svg',
  'messages_light': '/img/contact/icons/source/messages_light.svg',
  'notion': '/img/contact/icons/source/notion.svg',
  'notion_light': '/img/contact/icons/source/notion_light.svg',
  'phone': '/img/contact/icons/source/phone.svg',
  'phone_light': '/img/contact/icons/source/phone_light.svg',
  'twitter': '/img/contact/icons/source/twitter.svg',
  'twitter_light': '/img/contact/icons/source/twitter_light.svg',
  'twitter-platforms': '/img/contact/icons/source/twitter.svg',
  'twitter-platforms_light': '/img/contact/icons/source/twitter_light.svg',
  'instagram': '/img/contact/icons/source/instagram.svg',
  'instagram_light': '/img/contact/icons/source/instagram_light.svg',
  'whatsapp': '/img/contact/icons/source/whatsapp.svg',
  'whatsapp_light': '/img/contact/icons/source/whatsapp_light.svg',
  'zapier': '/img/contact/icons/source/zapier.svg',
  'zapier_light': '/img/contact/icons/source/zapier_light.svg',
  'make': '/img/contact/icons/source/make.svg',
  'make_light': '/img/contact/icons/source/make_light.svg',
};
